<template>
  <div class="dynamic-field-menu">
    <slot name="header"></slot>
    <slot name="body"></slot>
    <slot name="footer"></slot>
  </div>
</template>
<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    data: function () {
      return {};
    }
  });

</script>